interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) pages.push(i);
    else if (pages[pages.length - 1] !== -1) pages.push(-1);
  }

  const go = (p: number) => {
    if (p < 1 || p > total || p === current) return;
    onChange(p);
  };

  return (
    <nav className="flex items-center justify-center gap-1.5" aria-label="分页">
      <button
        type="button"
        onClick={() => go(current - 1)}
        disabled={current === 1}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line align-middle" /> 上一页
      </button>
      {pages.map((p, idx) =>
        p === -1 ? (
          <span key={`gap-${idx}`} className="px-1 text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => go(p)}
            className={`w-9 h-9 rounded-md text-sm cursor-pointer ${
              p === current
                ? "bg-primary-500 text-background-50 font-semibold"
                : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        )
      )}
      <button
        type="button"
        onClick={() => go(current + 1)}
        disabled={current === total}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页 <i className="ri-arrow-right-s-line align-middle" />
      </button>
    </nav>
  );
}